import { NgModule } from '@angular/core'

import { ProgressService } from './progress.service'

@NgModule({
  providers: [
    ProgressService,
  ],
})
export class ProgressModule {}
